








































































import { RightArrowOutline12 } from '@hb/coffee-icons';
import {
  defineComponent, computed, onMounted, ref, PropType,
} from '@vue/composition-api';
import store from '@/store';
import { jumpToNewVersion } from '@/shared/utils/jumpTo';
import { NewVersionEnum } from '@/enums/newVersionRoute';
import { ubtSetupModuleExpose, ubtSetupPageButton } from '@/shared/utils/ubt/ubt-setup';
import { getAndStoreRepaymentVersion } from '@/shared/utils/repaymentVersion';
import OverdueReminder from './overdue-reminder/index.vue';

export default defineComponent({
  name: 'RepayItem',
  components: {
    RightArrowOutline12,
    OverdueReminder,
  },
  props: {
    customStyle: {
      type: Object,
      required: false,
    },
  },
  setup() {
    /** 还款卡片数据 */
    const creditData = computed(() => store.state.home.creditData);

    /** 命中还款流程实验组 */
    const hitRepaymentExperiment = ref();

    /** 埋点参数 */
    const ubtParams = computed(() => {
      const {
        needRepayOrderNum = 0,
        overdueNum = 0,
        onTimeRepaymentOrdersCount = 0,
        sevenDayRepaymentOrdersCount = 0,
      } = creditData.value || {};
      let repaymentType = '超过7日到期';
      if (overdueNum > 0) {
        repaymentType = '逾期';
      } else if (onTimeRepaymentOrdersCount > 0) {
        repaymentType = '按期';
      } else if (sevenDayRepaymentOrdersCount > 0) {
        repaymentType = '7日内到期';
      }
      return {
        quantityType: Number(needRepayOrderNum) > 1 ? '多笔' : '单笔',
        repaymentType,
      };
    });

    /** 逾期+当期还款订单数 */
    const overdueAndCurrentRepaymentOrderNum = computed(() => {
      const { overdueNum = 0, onTimeRepaymentOrdersCount = 0 } = creditData.value || {};
      return Number(overdueNum) + Number(onTimeRepaymentOrdersCount);
    });

    /** 非详情卡片文案展示 */
    const repaymentText = computed(() => {
      const { sevenDayRepaymentOrdersCount = 0, needRepayOrderNum = 0 } = creditData.value || {};
      const textInfo = {
        leftText: '',
        num: 0,
        rightText: '',
      };
      if (!hitRepaymentExperiment.value) {
        // 对照组只展示这个文案
        textInfo.leftText = '当前有';
        textInfo.num = needRepayOrderNum;
        textInfo.rightText = '笔待还';
      } else if (overdueAndCurrentRepaymentOrderNum.value > 0) {
        // 当前有逾期+当期还款订单数
        textInfo.leftText = '当前有';
        textInfo.num = overdueAndCurrentRepaymentOrderNum.value;
        textInfo.rightText = '笔待还';
      } else if (sevenDayRepaymentOrdersCount > 0) {
        // 近7日内有待还款订单数
        textInfo.leftText = '近7日内有';
        textInfo.num = sevenDayRepaymentOrdersCount;
        textInfo.rightText = '笔待还';
      } else {
        textInfo.leftText = '全部还款账单';
      }
      return textInfo;
    });

    /** 还款日期格式化 */
    const formattedRepaymentDate = computed(() => {
      const date = creditData.value?.planDetail?.repaymentDate;
      if (!date) {
        return '';
      }
      // 解析日期字符串，格式为 YYYY-MM-DD
      const [year, month, day] = date.split('-');
      if (!year || !month || !day) {
        return date; // 如果格式不正确，返回原字符串
      }
      // 转换为 月日 格式，去掉前导零
      const monthNum = parseInt(month, 10);
      const dayNum = parseInt(day, 10);
      return `${monthNum}月${dayNum}日`;
    });

    const goRepayBills = () => {
      jumpToNewVersion(NewVersionEnum.RepayBills, false);
    };

    const goRepay = () => {
      const {
        loanOrderId, commodityId, capitalCode = '', period,
      } = creditData.value?.planDetail || {};
      if (!loanOrderId || !commodityId) {
        // 返回数据异常应该兜底，跳转到还款账单页
        goRepayBills();
        return;
      }
      jumpToNewVersion(
        NewVersionEnum.Repay,
        false,
        `loanOrderId=${loanOrderId}&commodityId=${commodityId}&capitalCode=${capitalCode}&period=${period}&showRepaymentPlan=true`,
      );
    };

    const repayClick = (isDetail: boolean) => {
      ubtSetupPageButton('finance_loan_homePage_repay', {
        ...ubtParams.value,
      });
      if (isDetail && !!overdueAndCurrentRepaymentOrderNum.value) {
        goRepay();
      } else {
        goRepayBills();
      }
    };

    onMounted(async () => {
      hitRepaymentExperiment.value = await getAndStoreRepaymentVersion();
      ubtSetupModuleExpose('finance_loan_homePage_repay', ubtParams.value);
    });

    return {
      creditData,
      hitRepaymentExperiment,
      overdueAndCurrentRepaymentOrderNum,
      repaymentText,
      formattedRepaymentDate,
      repayClick,
    };
  },
});
